// boot/index.js
import { bootCommon } from './bootCommon';
import { bootLIM } from './bootLIM';

export const applyBoot = ({
    prev,
    operacao,
    profile,
    patchEndereco,
    empresaVaiEm,
    empresaArmazenada,
    parametro,
    operacaoParametros,
}) => {
    let next = prev;

    // 1) comum
    next = bootCommon({ prev: next, patchEndereco, empresaVaiEm, empresaArmazenada, parametro, operacaoParametros });

    // 2) específicos
    const isLIM = operacao?.sigla === 'LIM' || profile?.id === 'imoveis' || profile?.layout === 'imoveis';
    if (isLIM) {
        next = bootLIM({ prev: next, parametro, operacaoParametros });
    }

    return next;
};
